import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const optionChainSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.1742 12H12.4355C12.4355 12 10 12 10 14.4217L10 18.0532C10 20.4739 12.4355 20.4739 12.4355 20.4739H22.1742M22.1742 12V20.4739M22.1742 12H28.2608M22.1742 20.4739H28.2608M28.2608 12H35.5651C35.5651 12 38 12 38 14.4217V18.0532C38 20.4739 35.5651 20.4739 35.5651 20.4739H28.2608M28.2608 12V20.4739M22.1742 26.5261V35M22.1742 26.5261H35.5651C35.5651 26.5261 38 26.5261 38 28.9478V32.5793C38 35 35.5651 35 35.5651 35H22.1742M22.1742 26.5261H16.0876M22.1742 35H16.0876M16.0876 26.5261V35M16.0876 26.5261H12.4355C12.4355 26.5261 10 26.5261 10 28.9478L10 32.5793C10 35 12.4355 35 12.4355 35H16.0876"
            stroke="currentColor"/>
    </svg>
)

const OptionChain: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {optionChainSvg}
    </SvgIcon>
)

export default OptionChain